import { BordOneToneIcon } from 'components/NudosComponents';
import { nudosGray300, nudosTextcolor } from 'styles/styles.constants';

import './addCountryButton.scss';

interface IAddCountryButton {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

/**
 * Botón que abre el formulario para agregar un país nuevo.
 */
const AddCountryButton = ({ className = '', onClick, disabled }: IAddCountryButton) => {
  const iconStroke = disabled ? nudosGray300 : nudosTextcolor;

  return (
    <button type="button" className={`addCountryButton ${className}`} disabled={disabled} onClick={onClick}>
      <span className="addCountryButtonIcon">
        <BordOneToneIcon variant="plusCircle" standardSize={16} stroke={iconStroke} />
      </span>
      <span className="addCountryButtonText">Agregar país</span>
    </button>
  );
};

export default AddCountryButton;
